module.exports = __webpack_public_path__ + "img/2.80c1f393.png";